<template>
    <div id="portfolioDetails" :class="!checkMobileStatus ? 'web-portfolioDetails' : 'mobile-portfolioDetails'">

        <div class="container portfolio-details-container" v-for="(pItem, pKey) in postList"
             :style="pItem.isActive ? {'display' : 'block'} : {'display' : 'none'}">

            <div class="portfolio-details-header-container">
                <div class="portfolio-details-header-left-container">
                    <el-button class="btn btn-default" v-if="pKey !== 0" @click="prevPortfolio(pKey)">
                        <i class="fa" :class="!checkMobileStatus ? 'fa-angle-left' : 'fa-long-arrow-left'" aria-hidden="true"></i>{{lang("Prev")}}
                    </el-button>
                </div>

                <div class="portfolio-details-header-right-container">
<!--                    <el-button class="btn el-button&#45;&#45;primary">-->
<!--                        <i class="fa fa-file-pdf-o" aria-hidden="true"></i>{{lang("Download")}}-->
<!--                    </el-button>-->

                    <el-button class="btn el-button--primary" v-if="(pKey+1) !== postList.length" @click="nextPortfolio(pKey)">
                        {{lang("Next")}}<i class="fa" :class="!checkMobileStatus ? 'fa-angle-right' : 'fa-long-arrow-right'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>

            <div class="portfolio-details-content-container">

                <div class="portfolio-header-container">
                    <div class="portfolio-header-description col-md-12">
                        <label>{{lang("Learning Journeys Name")}}: </label>
                        <p>{{porDesc}}</p>
                    </div>

                    <div class="portfolio-header-class-name col-md-6">
                        <label>{{lang("Class Name")}}: </label>
                        <p>{{porClassName}}</p>
                    </div>

                    <div class="portfolio-header-learner-profiles col-md-6">
                        <label>{{lang("Learner Profiles")}}: </label>
                        <p>{{porLearnerProfiles}}</p>
                    </div>
                </div>

                <div class="each-portfolio-details-container">
                    <div class="each-portfolio-details-header-container">
                        <h4>{{lang("Finding Out")}}: {{pItem.PostContent}}</h4>
                        <small class="portfolio-created-date">
                            <i class="material-icons">date_range</i>{{lang("Date of observation")}}: {{pItem.PostCreatedDate_convert}}
                        </small>
                    </div>

                    <div class="portfolio-details-gallery-container">
                        <!-- Original -->
                        <div class="portfolio-big-image-container" v-if="!checkMobileStatus">
                            <div class="slideshow-container" v-for="(mItem, mKey) in mediaList[pItem.PostID]">
                                <div class="mySlides" :class="mItem.active ? 'active' : ''" :id="'portfolio-big-image-'+mKey">
                                    <img v-if="filesIsImage(mItem)" :src="getSource(mItem)">

                                    <video controls v-if="filesIsVideo(mItem)">
                                        <source :src="getSource(mItem)">
                                    </video>
                                </div>
                            </div>

                            <a class="prev" @click="plusSlides(-1, pItem.PostID)">&#10094;</a>
                            <a class="next" @click="plusSlides(1, pItem.PostID)">&#10095;</a>
                        </div>

                        <br>

                        <!-- Preview -->
                        <div class="portfolio-small-image-container" v-if="!checkMobileStatus">
                            <div class="portfolio-small-image" v-for="mItem in mediaList[pItem.PostID]">
                                <img v-if="filesIsImage(mItem)" :src="getSource(mItem)"
                                     :style="[mItem.active ? {'opacity' : '0.8'} : {'opacity' : '1'}]" />

                                <!-- controls -->
                                <video v-if="filesIsVideo(mItem)" :style="[mItem.active ? {'opacity' : '0.8'} : {'opacity' : '1'}]">
                                    <source :src="getSource(mItem)">
                                </video>
                            </div>
                        </div>

                        <div class="mobile-portfolio-small-image-container" v-if="checkMobileStatus">
                            <div class="mobile-portfolio-carousel-wrap-container">
                                <b-carousel id="carousel1" class="portfolio-carousel"
                                            indicators
                                            :controls="!isNull(mediaList[pItem.PostID]) && mediaList[pItem.PostID].length>1"
                                            background="#ccc"
                                            :interval="0">
                                    <div class="mobile-portfolio-carousel-wrap" v-for="mItem in mediaList[pItem.PostID]">
                                        <b-carousel-slide>
                                            <img v-if="filesIsImage(mItem)" :src="getSource(mItem)" />

                                            <video controls v-if="filesIsVideo(mItem)">
                                                <source :src="getSource(mItem)">
                                            </video>
                                        </b-carousel-slide>
                                    </div>
                                </b-carousel>
                            </div>
                        </div>

                    </div>

                    <div class="portfolio-details-content">
                        <div class="portfolio-inquiry-cycle" v-if="pItem.PortfolioDetailsPortfolio.length > 0">
                            <label style="display: inline-block!important; margin-right: 10px;">{{lang("Inquiry Cycle")}}</label>
                            <span v-for="inquiryItems in pItem.PortfolioDetailsPortfolio">
                                <span class="ljInquiryCycleResult">
                                    {{inquiryItems.PostPorDtlPorValue}}
                                </span>
                            </span>
                        </div>

                        <div class="portfolio-research-question">
                            <div v-if="!checkMobileStatus">
                                <div class="col-md-3 common-porDetails" style="display: inline-block;">
                                    <label>{{lang("Research Question")}}</label>
                                </div>

                                <div class="col-md-9 common-porDetails" style="display: inline-block; vertical-align: middle;">
                                    <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                              :value="pItem.PortfolioDetailsResearchQuestion"></el-input>
                                </div>
                            </div>

                            <el-collapse v-if="checkMobileStatus">
                                <el-collapse-item class="mobile-collapse-container" name="1">
                                    <template slot="title">
                                        <span>{{lang("Research Question")}}</span>
                                    </template>

                                    <hr/>

                                    <div class="mobile-portfolio-research-question">
                                        <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                                  :value="pItem.PortfolioDetailsResearchQuestion"></el-input>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>

                        <hr v-if="!checkMobileStatus" />

                        <div class="portfolio-development-goals">
                            <div v-if="!checkMobileStatus">
                                <div class="col-md-3 common-porDetails" style="display: inline-block;">
                                    <label>{{lang("Connection with long-term goals")}}</label>
                                </div>

                                <div class="col-md-9 common-porDetails" style="display: inline-block; vertical-align: middle;">
                                    <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                              :value="pItem.PostPorDtlDevelopmentGoals"></el-input>
                                </div>
                            </div>

                            <el-collapse v-if="checkMobileStatus">
                                <el-collapse-item class="mobile-collapse-container" name="1">
                                    <template slot="title">
                                        <span>{{lang("Connection with long-term goals")}}</span>
                                    </template>

                                    <hr/>

                                    <div class="mobile-portfolio-development-goals">
                                        <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                                  :value="pItem.PostPorDtlDevelopmentGoals"></el-input>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>

                        <hr v-if="!checkMobileStatus" />

                        <div class="portfolio-observations">
                            <div v-if="!checkMobileStatus">
                                <div class="col-md-3 common-porDetails" style="display: inline-block;">
                                    <label>{{lang("Observations")}}</label>
                                </div>

                                <div class="col-md-9 common-porDetails" style="display: inline-block; vertical-align: middle;">
                                    <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                              :value="pItem.PortfolioDetailsObservations"></el-input>
                                </div>
                            </div>

                            <el-collapse v-if="checkMobileStatus">
                                <el-collapse-item class="mobile-collapse-container" name="1">
                                    <template slot="title">
                                        <span>{{lang("Observations")}}</span>
                                    </template>

                                    <hr/>

                                    <div class="mobile-portfolio-observations">
                                        <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                                  :value="pItem.PortfolioDetailsObservations"></el-input>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>

                        <hr v-if="!checkMobileStatus" />

                        <div class="portfolio-analysis">
                            <div v-if="!checkMobileStatus">
                                <div class="col-md-3 common-porDetails" style="display: inline-block;">
                                    <label>{{lang("Analysis")}}</label>
                                </div>

                                <div class="col-md-9 common-porDetails" style="display: inline-block; vertical-align: middle;">
                                    <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                              :value="pItem.PortfolioDetailsAnalysis"></el-input>
                                </div>
                            </div>

                            <el-collapse v-if="checkMobileStatus">
                                <el-collapse-item class="mobile-collapse-container" name="1">
                                    <template slot="title">
                                        <span>{{lang("Analysis")}}</span>
                                    </template>

                                    <hr/>

                                    <div class="mobile-portfolio-analysis">
                                        <el-input type="textarea" rows="3" readonly="readonly" class="common-textarea"
                                                  :value="pItem.PortfolioDetailsAnalysis"></el-input>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>

                <div class="portfolio-themes-container" v-if="pItem.PortfolioDetailsThemes.length > 0">
                    <data-tables :data="pItem.PortfolioDetailsThemes">
                        <el-table-column v-for="info in detailsThemesValueTable"
                                         :prop="info.prop"
                                         :label="info.label"
                                         :key="info.prop"
                                         sortable="custom"
                                         :width="!checkMobileStatus ? 'auto' : '180'">
                        </el-table-column>
                    </data-tables>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import Vue from 'vue';
    import {lang} from '../locale/index';

    export default {
        name: "PortfolioDetails",
        data() {
            return {
                portfolioID: '',
                connection: '',
                analysis: '',
                porDesc: '',
                porClassName: '',
                porLearnerProfiles: '',

                postList: [],
                mediaList: [],
                arr_inquiryCycle: [],
                arrobj_detailsThemes: [],
                detailsThemesValueTable: [
                    {
                        prop: "PostPorDtlThmEnduringThemes",
                        label: lang("Enduring Themes")
                    }, {
                        prop: "PostPorDtlThmBigIdeas",
                        label: lang("Big Ideas")
                    }, {
                        prop: "PostPorDtlThmConcepts",
                        label: lang("Key Concepts")
                    }, {
                        prop: "PostPorDtlThmConceptsRelated",
                        label: lang("Key Concepts")+' Related'
                    }
                ],

                isImage: false,
                isAudio: false,
                isVideo: false,
                isFile: false,
                checkMobileStatus: false,

                slideIndex: 0,
                byPassToken: "BYPASSTOKEN999111000333",
            };
        },
        async created() {
            if (this.$route.query.id != null || this.$route.query.id !== undefined) {
                this.getPortfolioPost(decodeURI(this.$route.query.id));
            } else {
                this.$router.go(-1);
                // this.$router.push('/Portfolio');
            }

            window.addEventListener('resize', this.isMobile);
        },
        destroyed () {
            window.removeEventListener('resize', this.isMobile);
        },
        methods: {
            lang,

            async getPortfolioPost(portfolioID) {
                try {
                    const response = await DataSource.shared.getPortfolioHeaderDetails(portfolioID, this.byPassToken);
                    if (response) {
                        switch (response.code) {
                            case "2":
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'no record found'
                                });
                                break;
                            case "88":
                                this.$router.push('/');
                                break;
                            case "99":
                                this.$router.push('/pendingapprover');
                                break;
                        }
                        response.HeaderTable.Table.forEach((m, index) => {
                            this.porDesc = m.PortfolioDesc;
                            this.porClassName = m.PortfolioClassName;
                            this.porLearnerProfiles = m.PortfolioLearnerProfiles;
                            // this.inputLearningStory = m.PortfolioTitle;
                            // this.taEnduringThemes = m.PortfolioEnduringThemes;
                            // this.taResearchQuestion = m.PortfolioResearchQuestion;
                            // this.PortfolioCreatedByConID = m.PortfolioCreatedBy;
                        });
                        let tempPortfolioDetails = [];
                        response.DetailsTable.Table.forEach((m, index) => {
                            let my_object = {
                                PostID: m.PortfolioDetailsPostID,
                                PostCreatedDate_convert: m.PortfolioDetailsPostCreatedDate,
                                PostContent: m.PortfolioDetailsTitle,
                                PortfolioDetailsResearchQuestion: m.PortfolioDetailsResearchQuestion,
                                PostPorDtlDevelopmentGoals: m.PortfolioDetailsGoals,
                                PortfolioDetailsObservations: m.PortfolioDetailsObservations,
                                PortfolioDetailsAnalysis: m.PortfolioDetailsAnalysis,
                                PostPorDtlAnalysisReflection: m.PortfolioDetailsObservations,
                                PostPorDtlID: m.PostPorDtlID
                            };

                            this.connection = m.PortfolioDetailsGoals;
                            this.analysis = m.PortfolioDetailsObservations;
                            tempPortfolioDetails.push(my_object);
                        });

                        await Promise.all(tempPortfolioDetails.map(async (m, index) => {
                            let portfolioDetailsPortfolio = [];
                            let postPortfolioDetailsThemes = [];

                            portfolioDetailsPortfolio = await this.getPostPortfolioDetailsPortfolio(m.PostPorDtlID);
                            postPortfolioDetailsThemes = await this.getPostPortfolioDetailsThemes(m.PostPorDtlID);

                            m.PortfolioDetailsPortfolio = portfolioDetailsPortfolio;
                            m.PortfolioDetailsThemes = postPortfolioDetailsThemes;
                            return m;
                        }));

                        this.postList = tempPortfolioDetails;

                        this.getImage();
                        this.postList = this.postList.map((m, pIndex) => {
                            m.newAnalysis = m.PostPorDtlAnalysisReflection;
                            m.newConnection = m.PostPorDtlDevelopmentGoals;
                            m.showContent = true;
                            m.showConnection = true;
                            m.showObservation = true;
                            m.noContentRemark = false;
                            m.noConnectionRemark = false;
                            m.noObservationRemark = false;

                            if (pIndex === 0) {
                                m.isActive = true;
                            } else {
                                m.isActive = false;
                            }

                            return m;
                        });
                    }
                } catch (e) {
                    this.results = e;
                }
            },

            async getImage() {
                this.slideIndex = 0;

                for (const post of this.postList) {
                    const response = await DataSource.shared.getPortfolioPostFile(post.PostID, this.byPassToken);
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '2') {
                            console.log('no data found');
                        } else {
                            response.Table.forEach((m, index) => {
                                if (index === 0) {
                                    m.active = true;
                                } else {
                                    m.active = false;
                                }
                            });

                            Vue.set(this.mediaList, post.PostID, response.Table);
                        }

                        this.showBigFiles(post.PostID);
                    }
                }

                // console.log(this.mediaList, "media list");
            },

            async getPostPortfolioDetailsPortfolio(postPortDtlID) {
                try {
                    const response = await DataSource.shared.getPostPortfolioDetailsPortfolioByPassToken(postPortDtlID, 'InquiryCycle', this.byPassToken);
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPostPortfolioDetailsPortfolio error');
                        } else if (response.code === '2') {
                            console.log('getPostPortfolioDetailsPortfolio no record');
                        } else {
                            this.arr_inquiryCycle = [];

                            response.Table.forEach(items => {
                                if (!this.arr_inquiryCycle.includes(items.PostPorDtlPorValue)) {
                                    this.arr_inquiryCycle.push(items.PostPorDtlPorValue);
                                }
                            });

                            return response.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },

            async getPostPortfolioDetailsThemes(postPortDtlID) {
                try {
                    const response = await DataSource.shared.getPostPortfolioDetailsThemesByPassToken(postPortDtlID, this.byPassToken);
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPostPortfolioDetailsThemes error');
                        } else if (response.code === '2') {
                            console.log('getPostPortfolioDetailsThemes no record');
                        } else {
                            this.arrobj_detailsThemes = [];

                            this.arrobj_detailsThemes = response.Table;

                            return response.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },

            getSource(obj) {
                let imgsrc = "";

                if (obj.PostItemFile === null || obj.PostItemFile === "")
                    imgsrc = "data:image/png;base64,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";
                else
                    imgsrc = "data:" + obj.PostItemFileType + ";base64," + obj.PostItemFile;
                return imgsrc;
            },

            filesIsImage(obj) {
                let ext = String(obj.PostItemFileExt).toUpperCase();
                let filesType = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                        filesType = true;
                        break;
                    default:
                        filesType = false;
                        break;
                }

                return filesType;
            },

            filesIsAudio(obj) {
                let ext = String(obj.PostItemFileExt).toUpperCase();
                let filesType = false;

                switch (ext) {
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                        filesType = true;
                        break;
                    default:
                        filesType = false;
                        break;
                }

                return filesType;
            },

            filesIsVideo(obj) {
                let ext = String(obj.PostItemFileExt).toUpperCase();
                let filesType = false;

                switch (ext) {
                    case ".MP4":
                        filesType = true;
                        break;
                    default:
                        filesType = false;
                        break;
                }

                return filesType;
            },

            plusSlides(n, postID) {
                if ((this.slideIndex+1) < this.mediaList[postID].length) {
                    if (n > 0) {
                        this.slideIndex = this.slideIndex + n;
                    } else {
                        this.slideIndex = this.mediaList[postID].length + n;
                    }
                } else {
                    this.slideIndex = 0;
                }

                this.showBigFiles(postID);
            },

            prevPortfolio(pfkey) {
                this.postList = this.postList.map((m, pIndex) => {
                    m.newAnalysis = m.PostPorDtlAnalysisReflection;
                    m.newConnection = m.PostPorDtlDevelopmentGoals;
                    m.showContent = true;
                    m.showConnection = true;
                    m.showObservation = true;
                    m.noContentRemark = false;
                    m.noConnectionRemark = false;
                    m.noObservationRemark = false;

                    if ((pfkey-1) === pIndex) {
                        m.isActive = true;
                    } else {
                        m.isActive = false;
                    }

                    return m;
                });
            },

            nextPortfolio(pfkey) {
                this.postList = this.postList.map((m, pIndex) => {
                    m.newAnalysis = m.PostPorDtlAnalysisReflection;
                    m.newConnection = m.PostPorDtlDevelopmentGoals;
                    m.showContent = true;
                    m.showConnection = true;
                    m.showObservation = true;
                    m.noContentRemark = false;
                    m.noConnectionRemark = false;
                    m.noObservationRemark = false;

                    if ((pfkey+1) === pIndex) {
                        m.isActive = true;
                    } else {
                        m.isActive = false;
                    }

                    return m;
                });
            },

            showBigFiles(postID) {
                this.mediaList[postID].forEach((m, index) => {
                    if (this.slideIndex === index) {
                        m.active = true;
                    } else {
                        m.active = false;
                    }
                });
            },

            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },

            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
        },
        mounted() {
            // this.getPortfolioPost("POR202000000158");
            this.isMobile();
        },
    }
</script>

<style scoped>
    .portfolio-details-container {
        background: white;
    }

    .web-portfolioDetails .portfolio-details-header-container {
        margin: 0px 0px 20px 0px;
        padding: 20px;
    }

    .portfolio-details-header-left-container {
        float: left;
    }

    .portfolio-details-header-right-container {
        float: right;
    }

    .portfolio-details-header-left-container .el-button,
    .portfolio-details-header-right-container .el-button {
        padding: 10px;
    }

    .portfolio-details-header-left-container .el-button i,
    .portfolio-details-header-right-container .el-button .fa-file-pdf-o {
        margin-right: 10px;
    }

    .portfolio-details-header-right-container .el-button i {
        margin-left: 10px;
    }

    .web-portfolioDetails .portfolio-details-content-container {
        padding: 20px;
    }

    .web-portfolioDetails .each-portfolio-details-container {
        background: #f7f7f7;
        padding: 30px;
        text-align: left;
    }

    .web-portfolioDetails .each-portfolio-details-container h4 {
        color: #409eff;
        font-weight: normal;
        margin-bottom: 0px;
    }

    .portfolio-created-date {
        color: #999;
        display: block;
    }

    .web-portfolioDetails .portfolio-details-gallery-container {
        margin: 30px 0px;
    }

    .web-portfolioDetails .portfolio-big-image-container {
        position: relative;
    }

    .web-portfolioDetails .slideshow-container .mySlides img,
    .web-portfolioDetails .slideshow-container .mySlides video {
        width:100%;
        height: 500px;
    }

    .web-portfolioDetails .portfolio-small-image {
        display: inline-block;
        margin-right: 10px;
    }

    .web-portfolioDetails .portfolio-small-image img,
    .web-portfolioDetails .portfolio-small-image video {
        width: 100px;
        height: 100px;
        border-radius: 8px;
        object-fit: cover;
        vertical-align: top;
    }

    .web-portfolioDetails .portfolio-inquiry-cycle label,
    .web-portfolioDetails .portfolio-research-question label,
    .web-portfolioDetails .portfolio-development-goals label,
    .web-portfolioDetails .portfolio-observations label,
    .web-portfolioDetails .portfolio-analysis label,
    .web-portfolioDetails .portfolio-analysis-reflection label {
        color: #409eff;
        /*display: inline-block!important;*/
        /*max-width: 15%;*/
        /*margin-right: 20px;*/
    }

    .web-portfolioDetails .portfolio-development-goals p,
    .web-portfolioDetails .portfolio-analysis-reflection p {
        display: inline-block;
        margin: 0px;
        max-width: 80%;
        font-size: 12px;
    }

    .web-portfolioDetails .portfolio-header-container label {
        color: #409eff;
    }

    .portfolio-header-container label,
    .portfolio-header-container p {
        margin: 0px;
    }

    .web-portfolioDetails .portfolio-header-container {
        padding: 15px 30px 0px 30px;
        background: #f7f7f7;
    }

    .portfolio-header-description,
    .portfolio-header-class-name,
    .portfolio-header-learner-profiles {
        text-align: left;
        padding: 0 0 10px 0;
        display: inline-block;
    }

    /* Image slider */
    .mySlides {display: none}
    img {vertical-align: middle;}

    /* Slideshow container */
    .slideshow-container {
        max-width: 1000px;
        position: relative;
        margin: auto;
    }

    .mySlides.active {
        display: block;
    }

    /* Next & previous buttons */
    .prev, .next {
        cursor: pointer;
        position: absolute;
        top: 50%;
        /*width: auto;*/
        /*padding: 16px;*/
        /*margin-top: -22px;*/
        width: 25px;
        background: gainsboro;
        text-align: center;
        color: white;
        font-weight: bold;
        font-size: 18px;
        transition: 0.6s ease;
        border-radius: 0 3px 3px 0;
        user-select: none;
    }

    /* Position the "next button" to the right */
    .next {
        right: 0;
        border-radius: 3px 0 0 3px;
    }

    /* On hover, add a black background color with a little bit see-through */
    .prev:hover, .next:hover {
        background-color: rgba(0,0,0,0.8);
    }

    /* The dots/bullets/indicators */
    .dot {
        cursor: pointer;
        height: 15px;
        width: 15px;
        margin: 0 2px;
        background-color: #bbb;
        border-radius: 50%;
        display: inline-block;
        transition: background-color 0.6s ease;
    }

    .active, .dot:hover {
        background-color: #717171;
    }

    /* Fading animation */
    .fade {
        -webkit-animation-name: fade;
        -webkit-animation-duration: 1.5s;
        animation-name: fade;
        animation-duration: 1.5s;
    }

    @-webkit-keyframes fade {
        from {opacity: .4}
        to {opacity: 1}
    }

    @keyframes fade {
        from {opacity: .4}
        to {opacity: 1}
    }

    /* On smaller screens, decrease text size */
    @media only screen and (max-width: 300px) {
        .prev, .next,.text {font-size: 11px}
    }


    /* Mobile Css */
    .mobile-portfolioDetails .container {
        padding: 0;
    }

    .mobile-portfolioDetails .portfolio-details-header-container {
        margin: 0px 0px 40px 0px;
        padding: 20px;
    }

    .mobile-portfolioDetails .each-portfolio-details-container {
        background: #f7f7f7;
        text-align: left;
    }

    .mobile-portfolioDetails .each-portfolio-details-header-container {
        padding: 20px;
    }

    .mobile-portfolioDetails .mobile-portfolio-carousel {
        text-shadow: 1px 1px 2px #333;
        height: 250px;
    }

    .mobile-portfolioDetails .mobile-portfolio-carousel-wrap img,
    .mobile-portfolioDetails .mobile-portfolio-carousel-wrap video {
        width: 250px;
        height: 200px;
        object-fit: contain;
    }

    .mobile-portfolioDetails .portfolio-details-content {
        padding: 20px;
    }

    .mobile-portfolioDetails .mobile-collapse-container span {
        padding: 0px 10px;
    }

    .mobile-portfolioDetails .mobile-collapse-container hr {
        margin: 0px;
    }

    .mobile-portfolioDetails .mobile-collapse-container .mobile-portfolio-research-question,
    .mobile-portfolioDetails .mobile-collapse-container .mobile-portfolio-development-goals,
    .mobile-portfolioDetails .mobile-collapse-container .mobile-portfolio-observations,
    .mobile-portfolioDetails .mobile-collapse-container .mobile-portfolio-analysis,
    .mobile-portfolioDetails .mobile-collapse-container .mobile-portfolio-analysis-reflection {
        padding: 0px 10px;
    }

    .mobile-portfolioDetails .portfolio-header-container {
        padding: 15px 20px 0px 20px;
        background: #f7f7f7;
    }


    .common-porDetails {
        padding: 0px;
    }

    .ljInquiryCycleResult {
        padding: 5px;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 5px;
        background: #DAE2FF;
        display: inline-block;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        color: #426DFF;
    }
</style>

<style>
    #portfolioDetails .common-textarea .el-textarea__inner {
        background: transparent;
        border: unset;
        resize: none;
    }

    .mobile-portfolioDetails .portfolio-carousel .carousel-inner {
        height: 240px;
        max-height: 240px;
    }

    .mobile-portfolioDetails .carousel-caption {
        right: unset;
        bottom: unset;
        z-index: unset;
        padding: 0px;
        left: 17%;
    }
</style>